import angular from 'angular';
import DefaultGrouping from './default';

class ContributorsGrouping extends DefaultGrouping {
  constructor() {
    super();

    this.key = 'contributors';
    this.displayName = "Contributors";
    this.groupByPulldown = true;
    this.secondarySortable = true;
    this.columnsByGroup = super.setColumns([
      'creationDate',
      'title',
      'content',
      'sources',
      'legalIssues',
      'contributors',
      'factDateish',
      'tags'
    ]);
  }

  getFactItems(contributors, branchId) {
    return contributors;
    // var items = [];
    // for (var i = 0; i < contributors.length; i++) {
    //   if (contributors[i].id !== branchId) {
    //     items.push(
    //       contributors[i].firstName.substring(0, 1) +
    //       contributors[i].lastName.substring(0, 1)
    //     );
    //   }
    // }
    // return items;
  };

  getDisplayText(contributors, branchId) {
    return this.getFactItems(contributors, branchId);
  };

  getMemoText(contributors, branchId) {
    return this.getFactItems(contributors, branchId);
  };

  getDocDisplayText(value) {
    return this.getDisplayText(value);
  }

  getSortingValue(contributors, branchId) {
    return this.getMemoText(contributors, branchId);
  }

  getHeaderDisplayName(branch) {
    return super.getDisplayName(branch)
  };
}

export default angular.module('groupings.contributors-grouping', [])
  .service('ContributorsGrouping', ContributorsGrouping)
  .name;



// WEBPACK FOOTER //
// ./project/groupings/contributors.js